export default "__VITE_ASSET__7075153f__"